import { Numeric0CircleIcon } from './Numeric0CircleIcon';

/**
 * author: Contributors
 * id 802F5332-8865-46C9-890D-130209044E17
 * name numeric-0-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-0-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number0CircleIcon = Numeric0CircleIcon;
export default Number0CircleIcon